'use client';
import { isValidElement, cloneElement, Children } from 'react';
import { useTheme, css, ClassNames, Box, getColorByToken } from '@wanteddev/wds-engine';
import { getWrapperStyle } from './style.mjs';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

var Interaction = ({
  color = "palette.label.normal",
  width = "100%",
  height = "100%"
}) => {
  return /* @__PURE__ */ jsx(
    Box,
    {
      "wds-component": "with-interaction",
      role: "presentation",
      sx: (theme) => css`
        overflow: hidden;
        position: absolute;
        z-index: 0;
        box-sizing: content-box;
        border-radius: inherit;
        opacity: ${theme.opacity[0]};
        background-color: ${getColorByToken(theme, color)};
        will-change: opacity, transform;
        transition:
          opacity 0.15s ease,
          transform 0.15s ease;
        transform-origin: center;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        ${width && css`
          width: ${width};
        `}
        ${height && css`
          height: ${height};
        `}
      `
    }
  );
};
var WithInteraction = ({
  variant = "normal",
  children,
  scale,
  disabled,
  ...props
}) => {
  const theme = useTheme();
  if (isValidElement(children)) {
    const childrenProps = { ...children.props };
    childrenProps.children = /* @__PURE__ */ jsxs(Fragment, { children: [
      childrenProps.children,
      /* @__PURE__ */ jsx(Interaction, { ...props })
    ] });
    if (childrenProps.sx) {
      return cloneElement(children, {
        ...childrenProps,
        ref: children.ref ?? children.props.ref,
        sx: [
          css(getWrapperStyle(theme, { variant, scale, disabled })),
          ...Array.isArray(childrenProps.sx) ? childrenProps.sx : [childrenProps.sx]
        ]
      });
    }
    return /* @__PURE__ */ jsx(ClassNames, { children: ({ css: className }) => /* @__PURE__ */ jsx(Fragment, { children: cloneElement(children, {
      ...childrenProps,
      className: childrenProps?.className ? `${className(getWrapperStyle(theme, { variant, scale, disabled }))} ${childrenProps?.className}` : className(
        getWrapperStyle(theme, { variant, scale, disabled })
      ),
      ref: children.ref ?? children.props.ref
    }) }) });
  }
  return Children.count(children) > 1 ? Children.only(null) : null;
};
WithInteraction.displayName = "WithInteraction";
var with_interaction_default = WithInteraction;

export { with_interaction_default as default };
